/**
 * BookingCTACard - CTA banner prompting users to book a call or appointment.
 */
import React from 'react';

export interface BookingCTACardProps {
  variant?: string;
  headline?: string;
  title?: string;
  description?: string;
  subtitle?: string;
  cta_label?: string;
  cta_href?: string;
  className?: string;
}

const BookingCTACard: React.FC<BookingCTACardProps> = (props) => {
  const {
    className = '',
  } = props;
  const headline = props.headline || props.title || 'Ready to Get Started?';
  const description = props.description || props.subtitle || '';
  const ctaLabel = props.cta_label || 'Book a Free Call';
  const ctaHref = props.cta_href || '/contact';

  return (
    <section
      className={`layout-full layout-band ${className}`}
      style={{ background: 'var(--color-primary)', color: '#ffffff' }}
      aria-labelledby="booking-cta-heading"
    >
      <div className="layout-container layout-center" style={{ maxWidth: '700px', margin: '0 auto', textAlign: 'center' }}>
        <h2 id="booking-cta-heading" style={{ fontSize: 'clamp(1.5rem, 3vw, 2.5rem)', fontWeight: 'var(--font-weight-bold)', marginBottom: description ? 'var(--spacing-4)' : 'var(--spacing-8)', color: 'inherit' }}>
          {headline}
        </h2>
        {description && (
          <p style={{ fontSize: 'var(--font-size-lg)', color: '#ffffff', marginBottom: 'var(--spacing-8)' }}>
            {description}
          </p>
        )}
        <a
          href={ctaHref}
          className="btn btn-lg"
          style={{ backgroundColor: '#ffffff', color: 'var(--color-primary)', borderColor: '#ffffff', fontWeight: 'var(--font-weight-bold)' }}
        >
          {ctaLabel}
        </a>
      </div>
    </section>
  );
};

export default BookingCTACard;
